import React from "react";
import { colorWithAlpha } from "repoV2/features/Common/modules/Colors/utils/rgbColors.utils";
import { useCheckoutThemeContext } from "repoV2/features/CheckoutPages/modules/CheckoutThemeContextProvider";
import { DISCOUNT_OFF_TYPES } from "repoV2/features/Listing/Listing.constants";
import { classNames } from "repoV2/utils/common/render/classNames";
import { useCoupon } from "./Coupon.utils";
import styles from "./Coupon.module.scss";

export type ICoupon = {
    code: string;
    value: number;
    expiry: string;
    currency: string;
    type: number;
    couponType: number;
    appliedCouponCodeValue?: string;
    onApplyCouponCodeClick: ({
        couponType,
        code,
    }: {
        couponType?: number | undefined;
        code?: string | undefined;
    }) => void;
    description?: string;
};

const Coupon = ({
    code,
    value,
    expiry,
    type,
    currency,
    couponType,
    appliedCouponCodeValue = "",
    onApplyCouponCodeClick,
    description = "",
}: ICoupon) => {
    const { onApplyButtonClick, getCouponCodeDate } = useCoupon({
        code,
        couponType,
        onApplyCouponCodeClick,
    });
    const {
        colors: { color1 },
    } = useCheckoutThemeContext();

    const discountText =
        type === DISCOUNT_OFF_TYPES.PERCENTAGE ? `${value}%` : "FLAT";

    const couponTextAmount =
        type === DISCOUNT_OFF_TYPES.PERCENTAGE
            ? `${value}%`
            : `${currency} ${value}`;

    return (
        <div className={styles.couponRoot}>
            <div className={styles.couponImageStyle}>
                <div className={styles.innerCouponImageStyle} />
                <div className={styles.flatOffText}>{discountText} OFF</div>
            </div>

            <div
                className={styles.innerCoupon}
                style={{
                    backgroundColor: colorWithAlpha(color1, 0.1),
                }}
            >
                <div className={styles.couponText}>
                    <div className={styles.linea}>{code}</div>
                    <div className={styles.lineb}>
                        {description ||
                            `Save ${couponTextAmount} with this coupon`}
                    </div>
                    <div className={styles.linec}>
                        Valid till {getCouponCodeDate(expiry)}
                    </div>
                </div>
                <div
                    className={classNames(
                        styles.applyText,
                        appliedCouponCodeValue === code
                            ? styles.appliedStyle
                            : styles.noApplyStyle
                    )}
                    onClick={onApplyButtonClick}
                >
                    {appliedCouponCodeValue === code ? "APPLIED" : "APPLY"}
                </div>
            </div>
        </div>
    );
};

export default Coupon;
